module.exports = __webpack_public_path__ + "img/hdzx_2.1a7a972a.png";